import { Grid, Typography, Button } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';

const ConfirmBeforeTypeSwitchModal = ({ cbOnApproval, noteContent }) => {
	const commonStyleClasses = useCommonStyles();
	return (
		<Grid container spacing={2} className={commonStyleClasses.modalContentStyle}>
			<Grid item xs={12}>
				<Typography variant="h5" color="primary" fontWeight="bold">
					{noteContent}
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<Button variant="contained" onClick={cbOnApproval}>
					Yes
				</Button>
			</Grid>
		</Grid>
	);
};

export default ConfirmBeforeTypeSwitchModal;
